import { z } from 'zod'
import { userSchema } from '../schemas/users.schemas'
import { CompanyUsersStatus } from '../types/companies.types'
import {
  NotificationStatus,
  NotificationType
} from '../types/notifications.types'
import { Language } from '../types/users.types'

export const usersParamsSchema = z.object({
  userId: z.uuid()
})

export const usersNotificationsParamsSchema = usersParamsSchema.extend({
  notificationId: z.uuid()
})

export const usersCompaniesParamsSchema = usersParamsSchema.extend({
  companyId: z.uuid()
})

export const userCompaniesQuerySchema = z.object({
  status: z.enum(CompanyUsersStatus).optional()
})

export type UserCompaniesQuery = z.infer<typeof userCompaniesQuerySchema>

export const deleteUserBodySchema = z.object({
  accessToken: z.string()
})

export const requestUserCompanyBodySchema = z.object({
  companyId: z.uuid()
})

export const updateUserBodySchema = userSchema
  .pick({
    phone: true,
    name: true,
    lastName: true,
    language: true,
    timezone: true,
    avatarUri: true
  })
  .partial()
  .refine(data => Object.keys(data).length > 0, {
    message: 'At least one field must be provided'
  })

export type UpdateUserBody = z.infer<typeof updateUserBodySchema>

export const updateUserFormSchema = z.object({
  name: z.string().min(1),
  lastName: z.string().min(1),
  phone: z.string().optional(),
  language: z.enum(Language).optional(),
  timezone: z.string().optional(),
  avatarUri: z.string().optional().nullable()
})
export type UpdateUserForm = z.infer<typeof updateUserFormSchema>

export const personalInfoSchema = updateUserFormSchema.pick({
  name: true,
  lastName: true,
  phone: true
})

export const configSchema = updateUserFormSchema.pick({
  avatarUri: true,
  timezone: true
})

export type PersonalInfoForm = z.infer<typeof personalInfoSchema>
export type ConfigInfoForm = z.infer<typeof configSchema>

export const userNotificationsQuerySchema = z.object({
  pageNumber: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(50).optional(),
  status: z.enum(NotificationStatus).optional(),
  companyId: z.uuid().optional(),
  type: z.enum(NotificationType).optional()
})

export const updateNotificationStatusSchema = z.object({
  status: z.enum([NotificationStatus.READ, NotificationStatus.UNREAD])
})
